import Nullstack from 'nullstack';
export default function IconLanguageHiragana({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-language-hiragana",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 5h7"
  }), "   ", Nullstack.element("path", {
    d: "M7 4c0 4.846 0 7 .5 8"
  }), "   ", Nullstack.element("path", {
    d: "M10 8.5c0 2.286 -2 4.5 -3.5 4.5s-2.5 -1.135 -2.5 -2c0 -2 1 -3 3 -3s5 .57 5 2.857c0 1.524 -.667 2.571 -2 3.143"
  }), "   ", Nullstack.element("path", {
    d: "M12 20l4 -9l4 9"
  }), "   ", Nullstack.element("path", {
    d: "M19.1 18h-6.2"
  }), " ");
}